import { render, staticRenderFns } from "./rangeLabelSlider.vue?vue&type=template&id=dbcedec6&scoped=true"
import script from "./rangeLabelSlider.vue?vue&type=script&lang=js"
export * from "./rangeLabelSlider.vue?vue&type=script&lang=js"
import style0 from "./rangeLabelSlider.vue?vue&type=style&index=0&id=dbcedec6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcedec6",
  null
  
)

export default component.exports